import { checkPermissions } from '@/utils/accesses'

// The scope rule of GLBA-13391 §2.6: a global or own-book organization grant
// reaches organizations through the admin endpoints; without either the viewer
// works inside their own organization only.
export const reachesOrganizations = permissions =>
  checkPermissions(permissions, ['organization_list']) ||
  checkPermissions(permissions, ['organization_list_own'])

export const isOwnOrganizationScope = permissions => !reachesOrganizations(permissions)

// A member who neither manages their organization nor reaches other ones.
export const isPlainMember = permissions =>
  isOwnOrganizationScope(permissions) &&
  !checkPermissions(permissions, ['user_access_organization'])
